// src/pages/Login/ResetPasswordConfirm.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const ResetPasswordConfirm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [password, setPassword] = useState('');
  const [error, setError]       = useState(null);
  const [token, setToken]       = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenParam = params.get('token');
    if (tokenParam) {
      setToken(tokenParam);
    }
  }, [location]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const res = await fetch('/api/users/reset-password-confirm', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token, password })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.message || 'Reset failed');
      } else {
        navigate("/login");
      }
    } catch (err) {
      setError('Reset failed. Please try again.');
      console.error(err);
    }
  };

  return (
    <section className="login">
      <style>{`header { display: none; }`}</style>
      <div className="container-fluid">
        <div className="row">
          {/* Left Column: Graphic */}
          <div className="col-xs-12 col-sm-6">
            <div className="login-graphic middle center">
              <img src="/images/Logo.svg" alt="Logo" />
            </div>
          </div>
          {/* Right Column: Form */}
          <div className="col-xs-12 col-sm-6 first-xs last-sm">
            <div className="login-form middle center">
              <form onSubmit={handleSubmit}>
                <h5 className="text-center">Reset Password</h5>
                {error && <p className="fail">{error}</p>}
                <div className="text-uppercase margin-top-l">New Password</div>
                <input 
                  type="password" 
                  name="Password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required 
                />
                <div className="form-footer margin-top-l middle">
                  <button 
                    type="button" 
                    className="text-link"
                    onClick={() => navigate("/login")}
                  >
                    or log in here
                  </button>
                  <button type="submit" data-value="question form">Reset</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPasswordConfirm;
